"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Svg = void 0;

var _stylitas = require("@creditas/stylitas");

var _helpers = require("./helpers");

var Svg = _stylitas.styled.svg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & > path {\n    stroke: ", ";\n  }\n"])), (0, _helpers.propTheme)('color', 'colorFontNeutral90'));

exports.Svg = Svg;